/* Dansk katalog for locale-inbox-vouchers-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'voucher.none': 'Ingen bilag',
  'voucher.noLedgerLines': 'Ingen hovedbogslinjer tilgængelige fra backend endnu.',
  'voucher.noLedger': 'Ingen hovedbogslinjer',
  'voucher.action': 'Handling',
  'voucher.title': 'Transaktioner',
  'voucher.incompleteBasis': 'Journaldækningen er ufuldstændig. Listen kan bruges til dokumentopslag, men må ikke læses som en komplet hovedbog eller bilagsliste.',
  'voucher.subtitle': 'Alle bogførte transaktioner for regnskabsåret',
  'voucher.backToVat': 'Tilbage til MVA-meldingen',
  'voucher.showAll': 'Vis alle transaktioner',
  'voucher.download': 'Download',
  'voucher.loadingPreview': 'Indlæser forhåndsvisning...',
  'voucher.cannotPreviewUse': 'Filen kan ikke forhåndsvises her. Brug Download, når du vil åbne den.',
  'voucher.cannotPreview': 'Denne filtype kan ikke forhåndsvises her.',
  'voucher.invoice': 'Faktura',
  'voucher.voucher': 'Bilag',
  'voucher.attachmentAttached': 'Bilag vedhæftet',
  'voucher.commentOptional': 'Kommentar (valgfri)',
  'voucher.commentPh': 'F.eks. forkert bogført beløb, dobbeltbogføring eller forkert leverandør.',
  'voucher.view': 'Visning',
  'voucher.viewHelp': 'Skift mellem bilagsliste, detaljerede posteringer og hovedbog grupperet pr. konto.',
  'voucher.view.bilag': 'Bilag',
  'voucher.view.detaljer': 'Detaljer',
  'voucher.view.hovedbok': 'Hovedbog',
  'voucher.searchPh': 'Søg på bilag, konto eller beløb',
  'voucher.searchHelp': 'Søg på bilagsnummer, modpart, konto/postering eller beløb. I hovedbogen kan du også søge på debet, kredit og saldo.',
  'voucher.filterHelp': 'Filtrér bilagene på type, vedhæftning, betalingsstatus, periode og beløb.',
  'voucher.amountTitle': 'Beløb på bilaget',
  'voucher.amountHelp': 'Netto er beløbet uden moms (selve omkostningen/indtægten), moms er afgiften, og brutto er totalbeløbet inklusive moms. Sammen med dato og bilagsnummer er dette nøgleoplysningerne i bogføringen.',
  'voucher.rowHelp': 'Hver række er ét bilag. Ikonet og mærkaten viser typen (salg, køb, leverandørfaktura, kreditnota, manuelt bilag), og du ser navn og bilagsnummer. Tryk på rækken for at åbne bilaget.',
  'voucher.net': 'Netto',
  'voucher.netHelp': 'Beløbet uden moms - selve omkostningen eller indtægten, der bogføres på konto.',
  'voucher.vat': 'Moms',
  'voucher.vatHelp': 'Merværdiafgiften på bilaget - udgående moms på salg, indgående (fradragsberettiget) moms på køb.',
  'voucher.gross': 'Brutto',
  'voucher.grossHelp': 'Totalbeløbet inklusive moms - netto plus moms. Dette er beløbet, der faktisk betales eller modtages.',
  'voucher.accountPh': 'F.eks. software, bank eller 6300',
  'voucher.account': 'Konto',
  'voucher.accountHelp': 'Kontoen fortæller, hvad bogføringen gælder - hentet fra kontoplanen. Kontonummeret afgør, hvor beløbet havner i regnskabet (1xxx aktiver, 2xxx gæld/egenkapital, 3xxx indtægter, 4-7xxx omkostninger). Tryk på listeikonet for at søge i kontoplanen.',
  'voucher.pickAccount': 'Vælg konto',
  'voucher.searchChart': 'Søg i kontoplanen...',
  'voucher.noDescription': 'Uden beskrivelse',
  'voucher.removeEntry': 'Fjern postering',
  'voucher.entryDate': 'Bilagsdato',
  'voucher.entryDateHelp': 'Datoen, bogføringen skal bogføres på. Den afgør, hvilken regnskabs- og momsperiode posteringen havner i.',
  'voucher.whatFor': 'Hvad gælder bogføringen?',
  'voucher.whatForHelp': 'En kort tekst, der forklarer, hvad bogføringen gælder. Vises i hovedbogen og gør det let at forstå posteringen senere.',
  'voucher.fromAccount': 'Fra konto',
  'voucher.toAccount': 'Til konto',
  'voucher.fromAccountCredit': 'Fra konto (kredit)',
  'voucher.fromAccountHelp': 'Kontoen, pengene går FRA - kreditsiden af bogføringen. Betaler du f.eks. husleje fra bankkontoen, er banken (1920) »Fra«. Kredit reducerer et aktiv eller øger gæld/indtægt.',
  'voucher.vatCode': 'Momskode',
  'voucher.vatCodeHelp': 'Momskoden styrer, hvordan moms beregnes og indberettes i mva-meldingen. Kode 86 bruges til fjernleverbare tjenester fra udlandet. Vareimport registreres via tolddeklarationen.',
  'voucher.swap': 'Byt Fra og Til',
  'voucher.swapHelp': 'Bytter om på Fra- og Til-kontoen på linjen. Nyttigt, hvis du har bogført debet og kredit omvendt.',
  'voucher.toAccountDebit': 'Til konto (debet)',
  'voucher.toAccountHelp': 'Kontoen, pengene går TIL - debetsiden af bogføringen. Gælder bogføringen husleje, er huslejekontoen (6300) »Til«. Debet øger en omkostning eller et aktiv.',
  'voucher.addLineHelp': 'Tilføjer en ny bogføringslinje i denne postering. Brug flere linjer, når beløbet skal fordeles på flere konti - alle linjerne skal tilsammen få debet og kredit til at gå i nul.',
  'voucher.attachHelp': 'Vedhæft dokumentation til bogføringen - kvittering, faktura eller andet bilag. Valgfrit, men anbefalet: god dokumentation gør regnskabet efterprøveligt. Du kan trække filer ind eller indsætte et skærmbillede.',
  'voucher.attachOptional': 'Vedhæftning (valgfri)',
  'voucher.uploadAttachment': 'Upload vedhæftning',
  'voucher.deleteAttachment': 'Slet vedhæftning',
  'voucher.openNewTab': 'Åbn i ny fane',
  'voucher.balance': 'Balance',
  'voucher.balanceHelp': 'Viser, om posteringen går op. »Balanceret« betyder, at sum Til (debet) er lig med sum Fra (kredit) - så kan bogføringen registreres. Er der en difference, skal du rette beløbene, så de går i nul.',
  'voucher.toDebit': 'Til (debet)',
  'voucher.fromCredit': 'Fra (kredit)',
  'voucher.posted': 'Bogført',
  'voucher.edit': 'Rediger',
  'voucher.newCopy': 'Ny kopi af fri postering',
  'voucher.newFree': 'Ny fri postering',
  'voucher.from': 'Fra',
  'voucher.to': 'Til',
  'voucher.sum': 'Sum',
  'voucher.newEntry': 'Ny postering',
  'voucher.newEntryHelp': 'Tilføjer endnu en postering (et nyt bilag) under den samme registrering. Hver postering har egen dato, beskrivelse og linjer og bogføres som sit eget bilag.',
  'voucher.postHelp': 'Bogfører posteringen/posteringerne i regnskabet. Knappen er først aktiv, når alle posteringer er balancerede - altså når debet og kredit går i nul.',
  'voucher.details': 'Detaljer',
  'voucher.statusBalanced': 'Balanceret',
  'voucher.statusMissingAccount': 'Mangler konto',
  'voucher.statusSameAccount': 'Samme konto',
  'voucher.statusEmpty': 'Tom',
  'voucher.statusUnbalanced': 'Ubalanceret',
  'voucher.attachDropHint': 'Træk og slip filer her, eller indsæt et skærmbillede med Ctrl+V',
  'voucher.chooseBothAccounts': 'Vælg både fra- og tilkonto.',
  'voucher.sameAccountWarning': 'Fra- og tilkonto kan ikke være den samme konto.',
  'voucher.balancedReady': 'Balanceret - klar til registrering',
  'voucher.enterAmount': 'Indtast et beløb.',
  'voucher.difference': 'Difference: {amount}',
  'voucher.postedTitlePlural': 'Bogføringer registreret',
  'voucher.postedTitleSingular': 'Bogføring registreret',
  'voucher.postedBodyPlural': '{count} posteringer er bogført.',
  'voucher.postedBodySingular': 'Posteringen er bogført.',
  'voucher.postedIntro': 'Sådan blev det bogført:',
  'voucher.descriptionRequired': 'Angiv en beskrivelse på alle posteringer, før du bogfører.',
  'voucher.saveFailed': 'Kunne ikke registrere bogføringen.',
  'voucher.backTo': 'Tilbage til {label}',
  'voucher.controlPoint': 'kontrolpunktet',
  'voucher.editTitle': 'Rediger fri postering',
  'voucher.freePosting': 'Fri postering',
  'voucher.editSubtitle': 'Opdater posteringen, og gem ændringerne i backend.',
  'voucher.correctPostedTitle': 'Ret bogført bilag',
  'voucher.correctPostedSubtitle': 'Originalen bevares. Plumme bogfører en tilbageførsel og et nyt erstatningsbilag i én handling.',
  'voucher.correctPostedNotice': 'Det oprindelige bilag og journalnummeret ændres ikke. Ændringen bliver en koblet tilbageførsel og erstatning.',
  'voucher.correctionReason': 'Årsag til rettelse',
  'voucher.correctionReasonPlaceholder': 'Beskriv, hvad der var forkert, og hvorfor bilaget rettes',
  'voucher.correctPostedAction': 'Ret bilag',
  'voucher.correctionPreview': 'Vis rettelse',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Præcis tilbageførsel',
  'voucher.correctionReplacement': 'Erstatningsbilag',
  'voucher.freePostingSubtitle': 'Manuelle posteringer - debet og kredit skal gå i nul',
  'voucher.freePostingTitleHelp': 'Fri postering lader dig bogføre manuelt direkte på konto, når du har brug for fuld kontrol - for eksempel rettelser, omposteringer eller posteringer, der ikke passer i et almindeligt køb eller salg. Du styrer selv, hvilke konti beløbet flyttes mellem.',
  'voucher.directVatWarningTitle': 'Advarsel: direkte postering på momskonto',
  'voucher.directVatWarningBody': 'Disse posteringer bogføres i hovedbogen, men kommer ikke med i MVA-meldingen. Brug almindeligt køb, salg eller tolddeklaration, når beløbet skal indberettes som moms.',
  'voucher.directVatExcluded': 'ikke med i MVA-meldingen',
  'voucher.directVatConfirmLabel': 'Skriv OK for at bekræfte, at du forstår konsekvensen',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Registrér posteringer',
  'voucher.registerEntrySingular': 'Registrér postering',
  'voucher.registering': 'Registrerer...',
  'voucher.creditWord': 'kredit',
  'voucher.debitWord': 'debet',
  'voucher.attachmentFallbackName': 'vedhæftning',
  'inbox.prevPage': 'Forrige side',
  'inbox.page': 'Side',
  'inbox.nextPage': 'Næste side',
  'inbox.zoomOut': 'Zoom ud',
  'inbox.zoomIn': 'Zoom ind',
  'inbox.rotate': 'Rotér bilag',
  'inbox.mainDoc': 'Hovedbilag',
  'inbox.moveTo': 'Flyt til',
  'inbox.payOperating': 'Driftskonto - 1920',
  'inbox.payCash': 'Kontant - 1900',
  'inbox.payPrivate': 'Privat udlæg',
  'inbox.payUnknown': 'Vælg betalingskilde ...',
  'inbox.suggestion': 'Forslag fra SuperPlumma',
  'inbox.docType': 'Bilagstype',
  'inbox.quickChoices': 'Hurtigvalg',
  'inbox.quickChoiceUse': 'Vælg, hvad hurtigvalget skal erstatte',
  'inbox.quickChoiceRemembered': 'Husket fra {count} tidligere bilag fra leverandøren.',
  'inbox.quickChoiceAccount': 'Erstat konto',
  'inbox.quickChoiceDescription': 'Erstat beskrivelse',
  'inbox.quickChoiceBoth': 'Erstat begge',
  'inbox.purchase': 'Køb',
  'inbox.supplierInvoice': 'Leverandørfaktura',
  'inbox.pickSupplier': 'Vælg leverandør',
  'inbox.invoiceNoPh': 'F.eks. 0012345',
  'inbox.toggleVatHelp': 'Tryk for at skifte mellem, om det beløb, du indtaster, er uden eller med moms. Plumme omregner automatisk og gemmer bruttobeløbet på bilagsforslaget.',
  'inbox.vatDeductionRate': 'Foreslået momsfradrag',
  'inbox.documentVatRateHint': 'Bilaget viser {documentRate} % moms. Forslaget bruger {deductionRate} % fradrag ud fra virksomhedens momsstatus og den valgte behandling.',
  'inbox.accountCategory': 'Konto/kategori',
  'inbox.accountHelp': 'SuperPlummas forslag er forvalgt. Tryk for at vælge en anden konto.',
  'inbox.dueDateFromReceipt': 'Bilaget har ingen forfaldsdato. Sat til bilagsdatoen.',
  'inbox.supplierNotSaved': 'Vælg en gemt leverandør, eller gem leverandøren, før du bogfører fakturaen.',
  'err.purchase.supplierNotSaved': 'Vælg en gemt leverandør, eller gem leverandøren, før du bogfører fakturaen.',
  'inbox.duplicateTitle': 'Mulig dobbeltpostering',
  'inbox.duplicateBody': 'Et bilag med samme dato og beløb er allerede bogført.',
  'inbox.duplicateSameSupplier': 'Et bilag med samme dato, beløb og leverandør er allerede bogført.',
  'inbox.duplicateUploadFile': 'Mulig dobbelt upload: nøjagtig samme fil ligger allerede i indbakken.',
  'inbox.duplicateUploadContent': 'Mulig dobbelt upload: samme leverandør og beløb som et andet bilag i indbakken, og bilagsdatoerne ligger inden for 7 dage.',
  'inbox.duplicateUploadCount': 'Gælder {count} andre bilag.',
  'inbox.setPaymentSource': 'Betalt fra',
  'inbox.bulkPaymentTitle': 'Betalt fra',
  'inbox.bulkPaymentLead': 'Kilden sættes på {count} bilag. Du kan ændre den på hvert enkelt bilag bagefter.',
  'inbox.bulkPaymentLabel': 'Betalt fra',
  'inbox.bulkPaymentHint': 'Bilagene bliver klar til bogføring med denne konto.',
  'inbox.bulkPaymentPick': 'Vælg en betalingskilde først.',
  'inbox.bulkPaymentConfirm': 'Sæt på {count} bilag',
  'inbox.bulkPaymentDone': 'Betalingskilde sat på {count} bilag.',
  'inbox.uploadPaymentSingleTitle': 'Betalt fra',
  'inbox.uploadPaymentBulkTitle': 'Fordel betalingskilde',
  'inbox.uploadPaymentAppliesTo': 'Gælder {count} valgte bilag',
  'inbox.uploadPaymentSelectFirst': 'Markér bilagene nedenfor, så sætter knapperne betalingskilden for dem.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Tilføj bankkonto først',
  'inbox.uploadPaymentOtherSource': 'Vælg en anden betalingskilde ...',
  'inbox.uploadPaymentOperating': 'Driftskonto',
  'inbox.uploadPaymentPrivate': 'Privat',
  'inbox.uploadPaymentPrivateRecommended': 'Anbefalet uden erhvervskonto',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analyserer',
  'inbox.collectionNotice': 'Inkassovarsel',
  'inbox.collectionNoticeTitle': 'Dette hører sammen med det oprindelige bilag',
  'inbox.collectionNoticeBody': 'Hovedkravet skal ikke bogføres eller momsføres igen. Knyt varslet til det oprindelige bilag; renter og inkassoomkostninger behandles særskilt uden moms.',
  'inbox.collectionNoticePrincipal': 'Hovedkrav',
  'inbox.collectionNoticeInterest': 'Renter',
  'inbox.collectionNoticeCosts': 'Inkassoomkostninger',
  'inbox.collectionNoticeCandidates': 'Mulige oprindelige bilag',
  'inbox.collectionNoticeLink': 'Knyt til',
  'inbox.collectionNoticeLinked': 'Inkassovarslet er knyttet til det oprindelige bilag.',
  'inbox.collectionNoticeLinkFailed': 'Kunne ikke knytte inkassovarslet til det oprindelige bilag.',
  'inbox.collectionNoticeOpenOriginal': 'Åbn det oprindelige bilag',
  'inbox.collectionNoticeNoCandidate': 'Der blev ikke fundet et sikkert forslag. Find eller upload den oprindelige faktura, før varslet behandles.',
  'inbox.collectionNoticeBookBlocked': 'Knyt til det oprindelige bilag før behandling',
  'inbox.uploadPaymentAssigned': 'Konto {account}',
  'inbox.uploadPaymentUnpaid': 'Ikke betalt endnu',
  'inbox.uploadPaymentUnpaidHint': 'Til leverandørfaktura, der skal stå som gæld, indtil den betales.',
  'inbox.uploadPaymentAnalyze': 'Lad Plumme finde betalingskilden',
  'inbox.uploadPaymentUnassigned': 'Ikke afklaret',
  'inbox.uploadPaymentSelectVisible': 'Vælg viste',
  'inbox.uploadPaymentShowAll': 'Vis alle',
  'inbox.uploadPaymentShowPending': 'Vis kun uafklarede',
  'inbox.uploadPaymentProgress': '{completed} af {count} afklaret',
  'inbox.uploadPaymentConfirm': 'Upload {count}',
  'inbox.uploadPaymentReceipt': 'Bilag',
  'inbox.cardNudgeTitle': '{count} bilag mangler betalingskilde',
  'inbox.cardNudgeText': 'Registrér kortene på bankkontiene, så genkender Plumme betalingen direkte fra kvitteringen. Kontotypen afgør, om købet bliver erhverv eller privat udlæg.',
  'inbox.cardNudgeAction': 'Registrér kort',
  'inbox.shortDescription': 'Kort beskrivelse af bilaget',
  'inbox.shrinkPreview': 'Formindsk forhåndsvisning',
  'inbox.growPreview': 'Forstør forhåndsvisning',
  'inbox.dragWidth': 'Træk for at ændre bredden',
  'inbox.sendTo': 'Send til:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Bankkobling',
  'inbox.filterReadyToPost': 'Klar til bogføring',
  'inbox.filterNeedsReview': 'Til kontrol',
  'inbox.filterAwaitingAnalysis': 'Venter på analyse',
  'inbox.toInbox': 'Til indbakke (bilag)',
  'inbox.toDocumentation': 'Til dokumentation',
  'inbox.selectAll': 'Vælg alle',
  'inbox.selectHint': 'Shift-klik for at vælge flere i træk',
  'inbox.reviewSelected': 'Start bogføring ({count})',
  'inbox.planTitle': 'Bogfør med SuperPlumma',
  'inbox.planLead': '{count} af {selected} valgte bilag bogføres nu.',
  'inbox.planNothing': 'Ingen af de valgte bilag kan bogføres, som de står nu.',
  'inbox.planWithNotes': '{count} med forvalgt betalingskilde',
  'inbox.planConfirm': 'Bogfør {count} bilag',
  'inbox.planShow': 'Vis',
  'inbox.planHide': 'Skjul',
  'inbox.planSameFile': 'Spærret: nøjagtig samme fil ligger allerede her ({count})',
  'inbox.planSameInvoiceNumber': 'Spærret: fakturanummeret er allerede registreret ({count})',
  'inbox.planSameContent': 'Springes over: mulig dobbelt upload ({count})',
  'inbox.planNeedsReview': 'Springes over: skal kontrolleres ({count})',
  'inbox.planMissingData': 'Springes over: mangler data ({count})',
  'inbox.planMissing': 'Springes over: findes ikke længere ({count})',
  'inbox.planAllowContent': 'Bogfør disse alligevel - jeg har tjekket, at det er forskellige køb',
  'inbox.planAllowContentWarn': 'Dubletterne bogføres som separate bilag. Kontrollér, at det stemmer, før du fortsætter.',
  'inbox.planResultTitle': 'Bogføringen er færdig',
  'inbox.planResultLead': '{booked} af {selected} valgte bilag blev bogført.',
  'inbox.planBooked': 'Bogført ({count})',
  'inbox.planSkipped': 'Sprunget over ({count})',
  'inbox.planFailed': 'Mislykkedes ({count})',
  'inbox.walkTitle': 'Bogføring af bilag',
  'inbox.walkLead': '{count} bilag i køen.',
  'inbox.walkReady': 'Klar',
  'inbox.walkNeedsReview': 'Kræver kontrol',
  'inbox.walkDuplicates': 'Mulige dubletter',
  'inbox.walkDuplicateOf': 'Samme som {names}.',
  'inbox.walkHint': 'Du kan lukke når som helst - dem, du ikke har behandlet, forbliver valgt.',
  'inbox.walkStart': 'Gennemgå alle {count}',
  'inbox.walkBookReady': 'Bogfør de {count} klar nu',
  'inbox.walkPosition': '{index} af {total}',
  'inbox.walkPause': 'Fortsæt senere',
  'inbox.walkTrash': 'Til papirkurv',
  'inbox.walkSkip': 'Spring over',
  'inbox.walkNext': 'Næste',
  'inbox.walkGone': 'Bilaget er væk',
  'inbox.walkGoneText': 'Det blev bogført, slettet eller flyttet, mens gennemgangen var åben.',
  'inbox.walkDoneTitle': 'Gennemgangen er færdig',
  'inbox.walkDoneLead': '{count} bilag gennemgået',
  'inbox.walkDoneCounts': '{booked} bogført, {skipped} sprunget over, {trashed} flyttet til papirkurven.',
  'inbox.clearSelection': 'Ryd valg',
  'inbox.restoreAll': 'Gendan alle',
  'inbox.deletePermanently': 'Slet permanent',
  'inbox.deleteAll': 'Slet alle',
  'inbox.downloadAll': 'Download valgte',
  'inbox.downloading': 'Downloader...',
  'inbox.postAllWithAi': 'Bogfør alle med SuperPlumma',
  'inbox.postWithAi': 'Bogfør {count} med SuperPlumma',
  'inbox.postNoneReady': 'Ingen af de valgte bilag er klar til bogføring. Brug »Start bogføring« for at tage dem ét ad gangen.',
  'inbox.uploadDocument': 'Upload dokument',
  'inbox.mergeToOne': 'Slå sammen til ét bilag',
  'inbox.dragToMerge': 'Træk for at slå bilag sammen',
  'inbox.restore': 'Gendan',
  'inbox.post': 'Bogfør',
  'inbox.archiveNote': 'Arkiv til dokumenter, der ikke skal bogføres som bilag.',
  'inbox.searchDocs': 'Søg i dokumenter...',
  'inbox.moveToTrash': 'Flyt til papirkurv',
  'inbox.defaultVoucherName': 'Bilag',
  'inbox.defaultDocumentName': 'Dokument',
  'inbox.docTypeSettlement': 'Afregning',
  'inbox.docTypeSupplierInvoice': 'Leverandørfaktura',
  'inbox.docTypeSaleVoucher': 'Salgsbilag',
  'inbox.docTypePurchaseVoucher': 'Købsbilag',
  'inbox.paySourcePrivate': 'Betalt privat',
  'inbox.paySourceCash': 'Kontant',
  'inbox.paySourceUnclear': 'Uafklaret betaling',
  'inbox.paySourceCompany': 'Virksomhedskonto',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % moms på bilaget · {deductionRate} % fradrag',
  'inbox.vatRateLabel': '{rate} % moms',
  'inbox.paidFromBank': 'Betalt fra bank',
  'inbox.supplierNotRead': 'Virksomhed ikke aflæst',
  'inbox.invoiceNumberLabel': 'Faktura {number}',
  'inbox.attachmentLinkMissing': 'Den vedhæftede fil mangler et tilgængeligt link.',
  'inbox.menuNewPurchase': 'Betalt køb',
  'inbox.menuFixedAsset': 'Driftsmiddel',
  'inbox.menuOtherSale': 'Andet salg',
  'inbox.menuOpenAttachment': 'Åbn vedhæftet fil',
  'inbox.menuDownload': 'Download',
  'inbox.menuSplitAgain': 'Del op igen',
  'inbox.reanalyze': 'Genanalysér',
  'inbox.analyze': 'Analysér',
  'inbox.previewDocumentFallback': 'Dokument',
  'inbox.previewMissingFileLink': 'Mangler fillink',
  'inbox.saveNotConnected': 'Lagring af bilagsforslag er ikke koblet til backend.',
  'inbox.suggestionUpdated': 'Bilagsforslaget er opdateret.',
  'inbox.suggestionSaveFailed': 'Kunne ikke gemme bilagsforslaget.',
  'inbox.settlementFromLabel': 'Afregning fra',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'Afregnings-ID',
  'inbox.settlementNetToBankLabel': 'Netto til bank',
  'inbox.suggestedInvoiceSingular': 'Foreslået faktura',
  'inbox.suggestedInvoicePlural': 'Flere mulige fakturaer',
  'inbox.selectInvoiceManually': 'Vælg faktura manuelt',
  'inbox.paidToggleOn': 'Betalt',
  'inbox.paidToggleOff': 'Ikke betalt – føres som leverandørgæld',
  'inbox.paidToLabel': 'Betalt til',
  'inbox.projectSaveFailed': 'Kunne ikke gemme projektet.',
  'inbox.awaitingOcrData': 'Venter på OCR-data',
  'inbox.showSuggestionAgain': 'Vis forslag igen',
  'inbox.maximizePreview': 'Maksimér forhåndsvisning',
  'inbox.uploadPartialAnalyzing': '{done} af {total} bilag blev uploadet. Analyserer dem, der kom ind ...',
  'inbox.uploadedSingle': 'Bilag uploadet.',
  'inbox.uploadedMultipleAnalyzing': '{count} bilag uploadet. Analyserer ...',
  'inbox.uploadFailedSingle': 'Kunne ikke uploade bilaget.',
  'inbox.uploadFailedMultiple': 'Kunne ikke uploade bilagene.',
  'inbox.uploadFailedGeneric': 'Kunne ikke uploade bilag.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} bilag står tilbage som »Venter på analyse«.',
  'inbox.uploadedButAnalysisFailedSingle': 'Bilaget blev uploadet, men analysen mislykkedes.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Bilagene blev uploadet, men analysen mislykkedes.',
  'inbox.partialAnalysisFailed': '{failed} af {total} bilag blev ikke analyseret. Prøv »Analysér« på rækken.',
  'inbox.documentAddedSingle': 'Dokument lagt i Dokumentation.',
  'inbox.documentAddedMultiple': 'Dokumenterne er lagt i Dokumentation.',
  'inbox.documentUploadFailed': 'Kunne ikke uploade dokument.',
  'inbox.analyzed': 'Bilaget er analyseret.',
  'inbox.analyzeActionFailed': 'Bilagsanalysen mislykkedes.',
  'inbox.bookedNoneReason': 'Ingen bilag blev bogført.',
  'inbox.bookedSummary': '{booked} bogført, {skipped} sprunget over.',
  'inbox.bookedOne': 'Bilaget er bogført.',
  'inbox.bookedCount': '{count} bilag er bogført.',
  'inbox.bookFailedFallback': 'Kunne ikke bogføre bilagene.',
  'inbox.setPaymentSourceFailed': 'Kunne ikke angive betalingskilden.',
  'inbox.moveToTrashFailed': 'Kunne ikke flytte bilag.',
  'inbox.movedToTrash': 'Bilag flyttet til papirkurven.',
  'inbox.movedToTrashCount': '{count} bilag flyttet til papirkurven.',
  'inbox.restoredOne': 'Bilag gendannet.',
  'inbox.restoredCount': '{count} bilag gendannet.',
  'inbox.restoreFailed': 'Kunne ikke gendanne bilag.',
  'inbox.confirmDeletePermanentOne': 'Slet bilaget permanent?',
  'inbox.confirmDeletePermanentMany': 'Slet valgte bilag permanent?',
  'inbox.deletedPermanently': 'Bilag slettet permanent.',
  'inbox.deleteFailed': 'Kunne ikke slette bilag.',
  'inbox.docMovedToTrash': 'Dokument flyttet til papirkurven.',
  'inbox.docMovedToTrashCount': '{count} dokumenter flyttet til papirkurven.',
  'inbox.docMoveToTrashFailed': 'Kunne ikke flytte dokument.',
  'inbox.docRestored': 'Dokument gendannet.',
  'inbox.docRestoredCount': '{count} dokumenter gendannet.',
  'inbox.docRestoreFailed': 'Kunne ikke gendanne dokument.',
  'inbox.confirmDeleteDocOne': 'Slet dokumentet permanent?',
  'inbox.confirmDeleteDocMany': 'Slet valgte dokumenter permanent?',
  'inbox.docDeletedPermanently': 'Dokument slettet permanent.',
  'inbox.docDeleteFailed': 'Kunne ikke slette dokument.',
  'inbox.downloadPartial': '{downloaded} af {total} filer blev downloadet. Resten kunne ikke hentes.',
  'inbox.downloadedZip': '{count} filer downloadet som zip.',
  'inbox.downloadedSingleFile': 'Filen er downloadet.',
  'inbox.downloadFilesFailed': 'Kunne ikke downloade filerne.',
  'inbox.movedToDocs': 'Bilag flyttet til Dokumentation.',
  'inbox.movedToDocsCount': '{count} bilag flyttet til Dokumentation.',
  'inbox.moveToDocsFailed': 'Kunne ikke flytte bilag til Dokumentation.',
  'inbox.mergedCount': '{count} bilag slået sammen.',
  'inbox.mergeFailed': 'Kunne ikke slå bilag sammen.',
  'inbox.splitAgainDone': 'Bilaget er delt op igen.',
  'inbox.splitAgainFailed': 'Kunne ikke dele bilaget op.',
  'inbox.addressCopied': 'Bilagsadresse kopieret.',
  'inbox.trashTitle': 'Papirkurv',
  'inbox.docsSubtitle': 'Arkiv til aftaler, kontrakter og dokumenter - ikke bilag til bogføring.',
  'inbox.inboxSubtitle': 'Upload eller videresend bilag via e-mail - vi aflæser, hvad vi kan.',
  'inbox.titleHelp': 'Indbakken er samlestedet for bilag, der er kommet ind, men endnu ikke er bogført. Upload filer, eller videresend kvitteringer og fakturaer via e-mail - SuperPlumma aflæser indholdet og gør dem klar til bogføring.',
  'inbox.docsWithCount': 'Dokumentation ({count})',
  'inbox.trashWithCount': 'Papirkurv ({count})',
});
